import React from "react"

const NetworksContext = React.createContext({})

const { Provider, Consumer } = NetworksContext

export { Provider, Consumer, NetworksContext }
